import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { InquiryService } from "../services/inquiry.service";


@Component({
    selector: 'app-akulaku-auth',
    templateUrl: './akulakuauth.component.html',
    styleUrls: ['./akulakuauth.component.css']
})
export class AkuLakuAuthComponent implements OnInit{    
    form: FormGroup;
    isSubmitted: boolean;
    hostname: any = environment.hostName;
    imgUri : string;
    maxLength: number = 13;
    refNumber: string;
    appId : string;
    isPaymentFailed: string;
    successPage: number;
    callbackUrl: string;
    amount: string;
    
    constructor(private router:Router,
        private apiService:RequestHelper,
        private activeteRouter:ActivatedRoute,
        private validateservice:InquiryService){
        this.isSubmitted = false;
    }

    ngOnInit(): void {
        this.imgUri = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/akulaku.png';
        this.form = new FormBuilder().group({
            phoneNumber: [null, [Validators.required, Validators.maxLength(this.maxLength)]],
            password: [null, [Validators.required]]
        })
        /** init data from data query param */
        this.activeteRouter.queryParams.subscribe(data => {
            this.refNumber=data.refNo;
            console.log("refnumber : "+this.refNumber);
            this.appId = data.appId;
            console.log("ref number -> ",this.refNumber);
            console.log("app id -> ",this.appId);
        })
        console.log("refnumber : "+this.refNumber);
        this.isPaymentFailed = "N";
        console.log("refnumber localstorage -> "+localStorage.getItem('invoice_akulaku'));
        console.log("refnumber query -> "+this.refNumber);
        var dataRefNumber = this.refNumber == null ? localStorage.getItem('invoice_akulaku') : this.refNumber;
        console.log("data ref final -> "+dataRefNumber);
        this.validateservice.validateUriPayment(dataRefNumber)
            .subscribe(data => {
                console.log("validate uri payment "+data);
                if (data == "1"){
                    this.isPaymentFailed = "P";
                }
            },error => console.log("error "+error));
        /** get data by ref number */
        this.validateservice.getOrderPayment(dataRefNumber)
            .subscribe(data => {
                console.log("data by ref number : "+JSON.stringify(data));
                this.callbackUrl = data.callbackPageUrl;
                console.log("url callback page : "+this.callbackUrl);
            }, error => console.log("error "+error));    
    }

    previousPage(){
        // TODO : untuk step payment done / payment success seharusnya redirect url nya dari param 'callbackPageUrl' ketika create order, bukan kembali ke halaman payment instruction
        //this.router.navigate(['/paylater-akulaku']);
        window.location.href=this.callbackUrl;
    }

    doLogin(){
        this.isSubmitted=false;
        if (this.form.controls["phoneNumber"].value == "0812000000" && this.form.controls["password"].value == "123456"){
            console.log("password and phone number true")
            if(!this.form.valid){
                console.log("login failed")
                this.isSubmitted=true;
                return;
            }else{
                console.log("success login")
                this.router.navigate(['/paylater-akulaku-inquiry', {
                    numberRef: this.refNumber
                }])
            }
        }else if (this.form.controls["phoneNumber"].value == "0812000000" && this.form.controls["password"].value == "111111") {
            console.log("payment failed !");
            this.isPaymentFailed = "Y";
            this.doFailedPayment();
            // seharusnya ketika step ini kirim notification ke core akulaku dengan status 90
        }else{
            console.log("password and phone number wrong");
            this.openDialog("PASSWORD AND PHONE NUMBER WRONG");
        }
    }

    openDialog(result){
        this.apiService.openDialog(result, 'paylater-akulaku-auth');
    }

    doFailedPayment(){
        var dataAppId = this.appId == null ? localStorage.getItem('appid_akulaku') : this.appId;
        var dataRefNumber = this.refNumber == null ? localStorage.getItem('invoice_akulaku') : this.refNumber.replace(/\s/g, "");
        console.log("data app id "+dataAppId+" and ref number "+dataRefNumber);
        var requestBody = {
            "appId" : dataAppId,
            "refNo" : dataRefNumber,
            "status" : 90,
            "sign" : "",
            "type" : "failed"
        }
        console.log("data request : => ",requestBody)
            this.validateservice.callbackPayment(requestBody).subscribe(data => {
                if (data.responseCode != null || data.responseCode == "0099"){
                    console.log("failed payment !");
                    this.successPage=0;
                    //this.openDialog("payment failed")
                }else if (data.code == 0){
                    console.log("success failed payment !");
                    //this.successPage=1;
                }
            }, error => console.log("error payment from be"))

        this.validateservice.getOrderPayment(this.refNumber).subscribe(data => {
            this.appId = data.appId == null ? localStorage.getItem('appid_akulaku') : data.appId;
            this.refNumber = data.refNo == null ? localStorage.getItem('invoice_akulaku') : data.refNo;
            this.amount = data.totalPrice == null ? localStorage.getItem('amount_akulaku') : data.totalPrice;
        }, error => console.log(error))
    }
}
